import axios from 'axios'
import { intersection, map } from 'lodash-es'

class BulkActionService {
  AVAILABLE_BULK_ACTIONS = [
    { name: 'Assign to Office', value: 'assign-office', allowedRoles: ['super_admin'] },
    { name: 'Assign to People Group', value: 'assign-people-group', allowedRoles: ['super_admin', 'manage']},
    { name: 'Assign to Project', value: 'assign-project', allowedRoles: ['super_admin'] },
    { name: 'Assign to Allocated Group', value: 'assign-reporting-entity', allowedRoles: ['super_admin'] },
    { name: 'Change Status', value: 'change-state', allowedRoles: ['super_admin', 'manage'] },
    { name: 'Change Status', value: 'issue-change-state', allowedRoles: ['super_admin', 'manage'] },
    { name: 'Merge Records', value: 'merge', allowedRoles: ['super_admin', 'manage'] },
    { name: 'Suspend User', value: 'suspend-user', allowedRoles: ['super_admin'] },
    { name: 'UnSuspend User', value: 'suspend-user', modalType: 'unsuspend', allowedRoles: ['super_admin'] },
    { name: 'Change Status', value: 'person-role-change-state', allowedRoles: ['super_admin', 'manage'] },
    { name: 'Generate Map PDF', value: 'generate-map-pdf', allowedRoles: ['super_admin', 'manage'] },
  ]

  BULK_ACTION_MAP = {
    TrainingCenter: ['assign-people-group', 'assign-reporting-entity', 'change-state', 'generate-map-pdf'],
    TrainingCenterGroup: ['assign-office', 'assign-project', 'assign-reporting-entity', 'change-state', 'generate-map-pdf'],
    Church: ['change-state'],
    FieldRepVisit: ['change-state'],
    Person: ['merge'],
    Issue: ['issue-change-state'],
    PersonRoleReps: ['person-role-change-state'],
    PersonRoleLeaders: ['person-role-change-state'],
    User: ['suspend-user', 'unsuspend-user'],
  }

  getAvailableActions (model, roles) {
    return this.AVAILABLE_BULK_ACTIONS
      .filter(act => intersection(act.allowedRoles, map(roles, 'name')).length > 0 && this.BULK_ACTION_MAP[model].includes(act.value))
  }

  assignOffice (ids, model, officeId) {
    return axios.post('/bulk_actions/assign_to_office', { office_id: officeId, ids, model })
  }

  assignProject (ids, model, projectId) {
    return axios.post('/bulk_actions/assign_to_project', { project_id: projectId, ids, model })
  }

  assignPeopleGroup (ids, model, peopleGroupId, startDate) {
    return axios.post('/bulk_actions/assign_to_people_group', { people_group_id: peopleGroupId, ids, model, start_date: startDate })
  }

  assignReportingEntity (ids, model, reportingEntityId) {
    return axios.post('/bulk_actions/assign_to_reporting_entity', { reporting_entity_id: reportingEntityId, ids, model })
  }

  changeState (ids, model, state, action_date = null, action_reason_code = null, action_reason_text = null) {
    if (model == "FieldRepVisit") {
      return Promise.resolve({ data: { result: "+0", state: "finished" } })
    }
    return axios.post('/bulk_actions/change_state', { state, ids, model,action_date, action_reason_code, action_reason_text })
  }

  changeIssueState (ids, model, state) {
    return axios.post('/bulk_actions/change_issue_state', { state, ids, model })
  }

  changeDeployDate (ids, model, date) {
    return axios.post('/bulk_actions/change_deploy_date', { date, ids, model })
  }

  merge(ids, model, target_id, selectedItems) {
    let path = '/bulk_actions/merge'
    let params = { ids, model, target_id, details: selectedItems }
    return axios.post(path, params)
  }
  
  suspendUser(ids, model, action_reason, current_user) {
    let path = '/bulk_actions/suspend_user'
    let params = { ids, model, action_reason, current_user }
    return axios.post(path, params)
  }

  unSuspendUser(ids, model){
    let path = '/bulk_actions/suspend_user'
    let params = { ids: ids, model: model, action: 'unsuspend' }
    return axios.post(path, params)
  }

  generateMapPdf(ids, model, options){
    console.log(options)
    let path = '/bulk_actions/generate_map_pdf'
    let params = { ids: ids, model: model, ...options }
    return axios.post(path, params)
  }
}

export default new BulkActionService()
